import { TypeInfo, visit, visitWithTypeInfo, Kind, isAbstractType, } from 'graphql';
export default class AddTypenameToAbstract {
    transformRequest(originalRequest, delegationContext, _transformationContext) {
        const document = addTypenameToAbstract(delegationContext.targetSchema, originalRequest.document);
        return {
            ...originalRequest,
            document,
        };
    }
}
function addTypenameToAbstract(targetSchema, document) {
    const typeInfo = new TypeInfo(targetSchema);
    return visit(document, visitWithTypeInfo(typeInfo, {
        [Kind.SELECTION_SET](node) {
            const parentType = typeInfo.getParentType();
            let selections = node.selections;
            if (parentType != null && isAbstractType(parentType)) {
                selections = selections.concat({
                    kind: Kind.FIELD,
                    name: {
                        kind: Kind.NAME,
                        value: '__typename',
                    },
                });
            }
            if (selections !== node.selections) {
                return {
                    ...node,
                    selections,
                };
            }
        },
    }));
}
//# sourceMappingURL=AddTypenameToAbstract.js.map